import {
	wrapper,
	createApiClient,
	PaginationParams,
	Result,
	ApiError,
} from "../base";
import ClickhouseServerDO = App.Data.ClickhouseServerDO;
import { PaginatedCollection } from "@/types/collections";

const basePath = `/environment/clickhouse-servers`;
const baseClient = createApiClient();

type ServerParams = PaginationParams & {
	sort?: string;
	"filter[search]"?: string;
};

export default class {
	getClickhouseServers(
		params: ServerParams = {}
	): Promise<Result<PaginatedCollection<ClickhouseServerDO>, ApiError>> {
		return wrapper(baseClient.get(`${basePath}`, { params }));
	}
	getNewClickhouseServer(): Promise<Result<ClickhouseServerDO, ApiError>> {
		return wrapper(baseClient.get(`${basePath}/new`));
	}
	createClickhouseServer(
		clickhouseServer: ClickhouseServerDO
	): Promise<Result<ClickhouseServerDO, ApiError>> {
		return wrapper(baseClient.post(`${basePath}`, clickhouseServer));
	}
	removeClickhouseServer(uuid: string): Promise<Result<string, ApiError>> {
		return wrapper(baseClient.delete(`${basePath}/${uuid}`));
	}
	setActiveClickhouseServer(
		uuid: string
	): Promise<Result<ClickhouseServerDO, ApiError>> {
		return wrapper(baseClient.put(`${basePath}/set-is-active/${uuid}`));
	}
	getClickhouseServer(
		uuid: string
	): Promise<Result<ClickhouseServerDO, ApiError>> {
		return wrapper(baseClient.get(`${basePath}/get-clickhouse-server/${uuid}`));
	}
	updateClickhouseServer(
		clickhouseServer: ClickhouseServerDO
	): Promise<Result<ClickhouseServerDO, ApiError>> {
		return wrapper(
			baseClient.put(`${basePath}/${clickhouseServer.uuid}`, clickhouseServer)
		);
	}
}
